
// Define variables
const modal = document.getElementById("verificationModal");
const downloadBtn = document.getElementById('downloadBtn');
const span = document.querySelector(".close");
const refresh_btn = document.getElementById("refresh_btn");
const Vrfy_Antr_Certi = document.getElementById("Vrfy_Antr_Certi");
const my_loder = document.getElementById("my_loder");
const authenticationForm = document.getElementById("authenticationForm");
const closeModalBtn = document.getElementById("closeModalBtn");
const successpopup = authenticationDetails => {
    const OurCartificatHTML = document.getElementById('successpopup');
    const content = `
    <div class="item">
                    <h4>Hologram Number :</h4>
                    <h4>${authenticationDetails.Certification_Number}</h4>
                </div>
                <div class="item">
                    <h4>Personality :</h4>
                    <h4 class="regular">${authenticationDetails.Signer_Name}</h4>
                </div>
                <div class="item">
                    <h4>Product Description :</h4>
                    <h4 class="regular">${authenticationDetails.Item_name}</h4>
                </div>
                <div class="item">
                    <h4>Result :</h4>
                    <h4 class="regular">${authenticationDetails.Authentication_status}</h4>
                </div>`;
    OurCartificatHTML.innerHTML = content;
    openModal();
};
const generateHtml = authenticationDetails => {
   var OurCartificatHTML = document.getElementById('downloadBtnContainer');

   var content = `
    <div style="width:627px; height:408px; padding:20px; text-align:center; border: 10px solid #787878">
         <div style="width:570px; height:350px; padding:20px; text-align:center; border: 5px solid #787878">
           <span style="font-size:30px; font-weight:bold">Certification Verification</span>
           <br><br>    
           <span style="font-size:20px"><b>Certification Number : ${authenticationDetails.Certification_Number}</b></span><br/><br/>
            <span style="font-size:20px"><b>Signer Name : ${authenticationDetails.Signer_Name}</b></span><br/><br/>
           <span style="font-size:15px"><i>Item Name : ${authenticationDetails.Item_name}</i></span> <br/><br/>
           <span style="font-size:20px">Authentication status :  ${authenticationDetails.Authentication_status}</span> <br/><br/>
    </div>
</div>
`;
   OurCartificatHTML.innerHTML = content;

}


const openloder = () => my_loder.style.display = "block";

const Closeloder = () => my_loder.style.display = "none";

// Function to open the modal
const openModal = () => modal.style.display = "block";

// Function to close the modal
const closeModal = () => modal.style.display = "none";

// Function to generate random numbers
const generateRandomNumbers = () => {
    let numbers = '';
    for (let i = 0; i < 5; i++) {
        numbers += Math.floor(Math.random() * 10);
    }
    return numbers;
};

// Function to update random numbers in the UI
const updateRandomNumbers = () => document.getElementById('numbers').textContent = generateRandomNumbers();

// Event listeners
window.onclick = event => {
    if (event.target === modal) 
      closeModal();
      
};

span.onclick = closeModal;
if (downloadBtn) { 
downloadBtn.addEventListener('click', event => {
    event.preventDefault();
    const container = document.getElementById('downloadBtnContainer');
    openPrintWindow(container.innerHTML); 
});
}
authenticationForm.addEventListener("submit", authenticateProduct);

// Function to authenticate the product
function authenticateProduct(event) {
    event.preventDefault();
     openloder();
    const input = document.getElementById("inputField").value;
    const numbers = document.getElementById('numbers').textContent;
    const numbersMatch = input === numbers;

    if (!/^[0-9]+$/.test(input) || !numbersMatch) {
        alert("Invalid input: Input must contain only numbers or numbers do not match.");
        updateRandomNumbers();
        Closeloder();
        return;
    }

    const userInput = document.getElementById('authInput').value.trim();
  // https://script.google.com/macros/s/AKfycbziFPDwXyvuZOO2sDzhHR3fjlhKTeH19-YIQJeRg8b7yYPIUILM-QbHVALOB-5R2WxM/exec
    const apiUrl = `https://script.google.com/macros/s/AKfycbwH25mq9lY55_DopZhfjxeUckEOmBrQ6jfhuLFaxGWUbmSGAXlET4uTSAcNNDb2DtDw/exec?userInput=${encodeURIComponent(userInput)}`;

    fetch(apiUrl)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            return response.json();
        })
        .then(data => {
          console.log(data,"data")
            if (data.isAuthenticated) {
                generateHtml(data);
                successpopup(data);
               Closeloder();
            } else {
                Closeloder();
                alert(`${data.Certification_Number} Authentication failed. Please enter a valid key.`);
                
            }
        })
        .catch(error => console.error('Error authenticating product:', error));
}

// Initial actions
updateRandomNumbers();

  // Function to open print window
const openPrintWindow = content => {
    const printWindow = window.open('Authentication', '_blank', 'width=1000,height=600');
    printWindow.document.write('<html><head><title>Print Window</title></head><body>' + content + '</body></html>');
    printWindow.document.close(); // Ensure the content is fully loaded
    
    // Wait a bit before printing and closing, adjust delays as necessary
    setTimeout(() => {
        printWindow.focus(); // Focus on the new window
        printWindow.print(); // Trigger the print dialog
        setTimeout(() => printWindow.close(), 500); // Close the window a bit after
    }, 1000);
};

refresh_btn.addEventListener('click', event => {
    event.preventDefault();
   updateRandomNumbers();
});

closeModalBtn.addEventListener('click', event => {
    event.preventDefault();
    closeModal();
    updateRandomNumbers();
});

const certificationInput = document.getElementById('authInput');
   const captchaInput = document.getElementById('inputField');

Vrfy_Antr_Certi.addEventListener('click', event => {
    event.preventDefault();
    closeModal();
   
    certificationInput.value = '';
    captchaInput.value = '';
});


